export default "__VITE_ASSET__5orBDNEb__"